export default {
  APPOINTMENT_STATUSES: {
    accepted: "accepted",
    approved: "approved",
    canceled: "cancelled",
    cancelled: "cancelled",
    completed: "completed",
    created: "created",
    installation_pending: "installation_pending",
    pending: "pending",
    running: "running"
  },
  APPOINTMENT_STATUS_MAP: {
    accepted: "Accepted",
    approved: "Approved",
    canceled: "Cancelled",
    cancelled: "Cancelled",
    completed: "Completed",
    created: "Created",
    installation_pending: "Installation Pending",
    pending: "Pending",
    running: "Running"
  },
  APPOINTMENT_STATUS_ORDER: [
    "created",
    "pending",
    "installation_pending",
    "accepted",
    "approved",
    "running",
    "completed",
    "canceled",
    "cancelled"
  ],
  APPOINTMENT_EDIT_MODE: {
    created: "PENDING",
    installation_pending: "PENDING",
    pending: "PENDING",
    accepted: "IN_PROGRESS",
    approved: "IN_PROGRESS",
    running: "IN_PROGRESS",
    canceled: "COMPLETED",
    cancelled: "COMPLETED",
    completed: "COMPLETED"
  },
  APPOINTMENT_STATUS_LEGEND_ORDER: {
    pending_unassigned: 0,
    pending_assigned: 1,
    accepted_pre_work: 2,
    accepted: 3,
    running: 4,
    compeleted_won_opportunity: 5,
    compeleted_lost_opportunity: 6
  },
  APPOINTMENT_SCHEDULE_LEGEND: {
    pending_unassigned: {
      label: "Pending",
      description: "Available for a technician or installer to be worked."
    },
    pending_assigned: {
      label: "Pending",
      subLabel: "(Assigned)",
      description: "Is assigned to a Technician or an installer to be worked."
    },
    accepted_pre_work: {
      label: "Claimed",
      subLabel: "(Pre-Work)",
      description:
        "Technician has claimed the appointment and is preparing to start trip."
    },
    accepted: {
      label: "Accepted",
      subLabel: "(Start Trip)",
      description:
        "Technician has started their trip to the location and is in transit."
    },
    traveling: {
      label: "Traveling",
      description: "The technician is driving to the location."
    },
    late: {
      label: "Late",
      description: "The tech has not arrived within the appointment window."
    },
    hold: {
      label: "Hold",
      description:
        "Temporary hold on the appointment time. Waiting on Tech to accept."
    },
    available_event: {
      label: "Event",
      subLabel: "(available for appointments)",
      description: "Technician is available to be assigned to appointments."
    },
    unavailable_event: {
      label: "Event",
      subLabel: "(unavailable for appointments)",
      description: "Technician is not available to be assigned appointments."
    },
    running: {
      label: "Working",
      subLabel: "(Running)",
      description:
        "Technician has finished their trip and is currently working at the job site."
    },
    compeleted_won_opportunity: {
      label: "Completed",
      subLabel: "(with Revenue)",
      description:
        "The work is completed and is tied to a won opportunity. (Revenue)"
    },
    compeleted_lost_opportunity: {
      label: "Completed",
      subLabel: "(without Revenue)",
      description: "The Tech is done and no additional revenue was added."
    }
  },
  // If updating BREAKPOINTS you must also update them in tailwind.config.js
  BREAKPOINTS: {
    sm: 640,
    // => @media (min-width: 640px) { ... }

    md: 853,
    // md: 768,
    // => @media (min-width: 768px) { ... }

    lg: 1024,
    // => @media (min-width: 1024px) { ... }

    xl: 1280
    // => @media (min-width: 1280px) { ... }
  },
  EDIT_MODE_PENDING: "PENDING",
  EDIT_MODE_IN_PROGRESS: "IN_PROGRESS",
  EDIT_MODE_COMPLETED: "COMPLETED",
  FULLCALENDAR_LICENSE_KEY: "0972890491-fcs-1760981418",
  QUOTE_STATUS_MAP: {
    pending: "open",
    approved: "accepted"
  },
  PERMIT_STATUS_MAP: {
    created: "New",
    submitted: "Submitted",
    pending: "Inspection Pending",
    passed_initial: "Inspection Passed - Initial",
    passed: "Inspection Passed - Final",
    failed: "Inspection Failed",
    canceled: "Cancelled",
    expired: "Expired"
  },
  DATE_FORMAT: "MM/DD/YY",
  DATE_YEAR_CAL_FORMAT: "YYYY-MM-DD",
  DATE_API_FORMAT: "MM/DD/YYYY",
  DATE_FORMAT_LONG: "MMMM Do, YYYY",
  DATE_FORMAT_SHORT: "MM/DD",
  DATE_TIME_FORMAT: "MM/DD/YY h:mm a",
  DATE_TIME_FORMAT_YEAR_LONG: "MM/DD/YYYY h:mm a",
  TIME_FORMAT: "h:mm a",
  TIME_PICKER_FORMAT: "hh:mm a",
  TIME_SECONDS_FORMAT: "h:mm:ss a",
  TIME_FORMAT_LONG: "hh:mm:ss a",
  JBW_WARRANTY_PROVIDER_NAME: "JB Warranties (Partner)",
  REPORT_FILTER_TYPES: {
    dateRange: "dateRange",
    date: "date",
    select: "select",
    toggle: "toggle",
    lineItemSelect: "lineItemSelect",
    workWeekFilter: "workWeekFilter"
  },
  TASK_PERIODS: [
    {
      value: "year",
      label: "Year"
    },
    {
      value: "quarter",
      label: "Quarter"
    },
    {
      value: "month",
      label: "Month"
    },
    {
      value: "week",
      label: "Week"
    },
    {
      value: "day",
      label: "Day"
    }
  ],
  MEMBERSHIP_PERIODS: [
    {
      value: "year",
      label: "Year"
    },
    {
      value: "month",
      label: "Month"
    }
  ],
  AGGREGATE_HEADERS: {
    days: "# of Days",
    invoices: "# of Invoices",
    customers: "# of Customers",
    departments: "# of Departments",
    systems: "# of Systems",
    jobs: "# of Jobs",
    membership_opportunity: "# of MO",
    membership_sold: "# of MS",
    balance: "Balance Due",
    revenue: "Total Revenue",
    sales_tax: "Total Sales Tax",
    sold: "Total Sold",
    cost: "Total Cost",
    total: "Total",
    calls: "# of Calls",
    sources: "# of Sources",
    assignees: "# of Assignees",
    providers: "# of Providers",
    programs: "# of Programs",
    items: "# of Items",
    equipment: "# of Equipment"
  },
  DURATION_HOUR_OPTIONS: [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
    { label: "11", value: 11 },
    { label: "12", value: 12 }
  ],
  DURATION_MINUTE_OPTIONS: [
    { label: "15", value: 15 },
    { label: "30", value: 30 },
    { label: "45", value: 45 }
  ],
  TERM_YEAR_OPTIONS_MAX: 15,
  APPOINTMENT_STATUS_TIME_LOSSES: {
    pending: {},
    accepted: {
      pending: ["accepted_time", "dispatch_time"]
    },
    running: {
      pending: ["accepted_time", "dispatch_time", "arrival_time"],
      accepted: ["arrival_time"]
    },
    completed: {
      pending: [
        "accepted_time",
        "dispatch_time",
        "arrival_time",
        "departure_time"
      ],
      accepted: ["arrival_time", "departure_time"],
      running: ["departure_time"]
    },
    cancelled: {
      pending: [
        "accepted_time",
        "dispatch_time",
        "arrival_time",
        "departure_time"
      ],
      accepted: ["arrival_time", "departure_time"],
      running: ["departure_time"]
    }
  },
  APPOINTMENT_STATUS_TIME_KEYS: {
    PARAM_ARRIVAL_TIME: "arrival_time",
    PARAM_DEPARTURE_TIME: "departure_time",
    PARAM_DISPATCH_TIME: "dispatch_time",
    PARAM_ACCEPTED_TIME: "accepted_time"
  },
  APPOINTMENT_STATUS_REQUIRED_TIMES: {
    accepted: ["accepted_time", "dispatch_time"],
    running: ["accepted_time", "dispatch_time", "arrival_time"],
    completed: [
      "accepted_time",
      "dispatch_time",
      "arrival_time",
      "departure_time"
    ],
    cancelled: [
      "accepted_time",
      "dispatch_time",
      "arrival_time",
      "departure_time"
    ]
  },
  NO_JOB_TIME_TOOLTIP_TEXT:
    "Waiting for completed appointment times to calculate",
  NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT:
    "Not Available - Job imported or created before verified times",
  ALLOWED_FILE_EXTENSIONS_ICON: [".jpg", ".jpeg", ".png", ".ico"],
  ALLOWED_FILE_EXTENSIONS_LOGO: [".jpg", ".jpeg", ".png"],
  AWS_S3_CDN_ROOT: "https://cdn-serviceshift.s3.amazonaws.com/",
  CDN_ROOT: "https://cdn.sera.tech",
  CDN_ROOT_TEMPLATE: "https://cdn.:env.sera.tech",
  MEGABYTE: 1000000.0,
  MAX_ASSET_FILE_SIZE_MB: 1.5,
  CALLS_EXPIRE_AFTER_MINUTES: 10,
  CALL_ROUTING_STATUS: {
    IN_PROGRESS: "in_progress",
    COMPLETED: "completed",
    RINGING: "ringing"
  },
  CALL_STATUS_MAP: {
    ringing: "Ringing",
    in_progress: "In Progress",
    missed: "Missed",
    abandoned: "Abandoned",
    completed: "Completed",
    voicemail: "Voicemail"
  },
  CALL_LIST_OPEN_DELAY: 250,
  CALL_MODAL_SEARCH_TERM_KEY: "name",
  ACTIVE_CALL_WIDTH: 380,
  PHOTO_UPLOAD_SOURCE: "admin_portal",
  PHOTO_MAX_SIZE: 20000000,
  SCHEDULE_DEFAULT_ZOOM: 55
};
